import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    alignSelf: 'center',
    display: 'flex',
    gap: '1rem',
  },
  root: {
    display: 'flex',
  },
  textButtonIcon: {
    marginRight: '0.5rem',
  },
  checkbox: {
    marginLeft: '-2px !important',
  },
  backToListButton: {
    marginRight: '10px',
  },
}));

export default useStyles;
